<div class="page-wrapper">
    <div class="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
        <div class="d-flex gap-3 align-items-center">
            <button (click)="back()" class="btn-white">
                <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.67969 3.1737H1.41258L3.55632 5.07945L3.09831 5.48945L0.165782 2.8853L3.09831 0.27832L3.55632 0.688311L1.41258 2.59406H6.67969V3.1737Z"
                        fill="#052B63" />
                </svg>
                Back
            </button>
            <H4 style="font-size: 18px; font-weight: bolder">SUMMARY</H4>
        </div>



        <div class="d-flex gap-2 align-items-center">
            <span>
                Filter:
            </span>


            <div class="amc-table-action-wrapper filter">


                <div class="toggle" role="button" (click)="toggleFilterOpen()">

                    <span class="current-filter">
                        {{formatActiveFilterTitle(activePeriodFilter)}}
                    </span>

                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.725659 3.30012H1.97026C2.21398 3.99882 2.87945 4.50193 3.66028 4.50193C4.44112 4.50193 5.09742 4.00608 5.34535 3.31464H12.9379C13.2618 3.31464 13.5254 3.05105 13.5254 2.7271C13.5254 2.40315 13.2618 2.13956 12.9379 2.13956H5.35528C5.11576 1.43322 4.44685 0.922852 3.66028 0.922852C2.87372 0.922852 2.20176 1.43551 1.96376 2.14453H0.726041C0.407443 2.14453 0.148438 2.40392 0.148438 2.72213C0.148438 3.04035 0.407825 3.29974 0.726041 3.29974L0.725659 3.30012ZM3.66028 2.06889C4.01518 2.06889 4.3036 2.35769 4.3036 2.71258C4.3036 3.06747 4.01479 3.35628 3.66028 3.35628C3.30578 3.35628 3.01659 3.06747 3.01659 2.71258C3.01659 2.35769 3.30539 2.06889 3.66028 2.06889Z"
                            fill="black" />
                        <path
                            d="M12.9478 10.8271H11.7101C11.4721 10.1181 10.8016 9.60547 10.0135 9.60547C9.22545 9.60547 8.55807 10.1155 8.31855 10.8218H0.735974C0.412026 10.8218 0.148438 11.0854 0.148438 11.4093C0.148438 11.7333 0.412026 11.9969 0.735974 11.9969H8.32849C8.57641 12.6883 9.23806 13.1842 10.0135 13.1842C10.789 13.1842 11.4598 12.6811 11.7036 11.9824H12.9482C13.2668 11.9824 13.5258 11.723 13.5258 11.4048C13.5258 11.0865 13.2664 10.8271 12.9482 10.8271H12.9478ZM10.0132 12.0385C9.65827 12.0385 9.36985 11.7497 9.36985 11.3948C9.36985 11.0399 9.65866 10.7515 10.0132 10.7515C10.3677 10.7515 10.6569 11.0403 10.6569 11.3948C10.6569 11.7493 10.3681 12.0385 10.0132 12.0385Z"
                            fill="black" />
                        <path
                            d="M12.9478 6.48535H11.7101C11.4721 5.77633 10.8016 5.26367 10.0135 5.26367C9.22545 5.26367 8.55807 5.77366 8.31855 6.48038H0.735974C0.412026 6.48038 0.148438 6.74397 0.148438 7.06792C0.148438 7.39187 0.412026 7.65546 0.735974 7.65546H8.32849C8.57641 8.3469 9.23806 8.84275 10.0135 8.84275C10.789 8.84275 11.4598 8.33964 11.7036 7.64094H12.9482C13.2668 7.64094 13.5258 7.38155 13.5258 7.06334C13.5258 6.74512 13.2664 6.48573 12.9482 6.48573L12.9478 6.48535ZM10.0132 7.69671C9.65827 7.69671 9.36985 7.40791 9.36985 7.05302C9.36985 6.69813 9.65866 6.40971 10.0132 6.40971C10.3677 6.40971 10.6569 6.69851 10.6569 7.0534C10.6569 7.40829 10.3681 7.69671 10.0132 7.69671Z"
                            fill="black" />
                    </svg>
                </div>
                <div class="dropdown-menu px-1" [ngClass]="{show: filterOpen}">
                    <div class="dropdown-wrapper">

                        <button class="action-btn" role="button" [ngClass]="{'active': activePeriodFilter == 'TODAY'}"
                            (click)="setActiveFilter({period: 'TODAY'})">
                            Today
                        </button>

                        <button class="action-btn" role="button" [ngClass]="{'active': activePeriodFilter == 'WEEK'}"
                            (click)="setActiveFilter({period: 'WEEK'})">
                            This Week
                        </button>

                        <button class="action-btn" role="button" [ngClass]="{'active': activePeriodFilter == 'MONTH'}"
                            (click)="setActiveFilter({period: 'MONTH'})">
                            This Month
                        </button>


                        <button class="action-btn" role="button" [ngClass]="{'active': activePeriodFilter == 'YEAR'}"
                            (click)="setActiveFilter({period: 'YEAR'})">
                            This Year
                        </button>

                        <mat-form-field>
                            <mat-date-range-input [dateFilter]="dateRangeFilter" [formGroup]="rangePickerForm"
                                [rangePicker]="picker" #rangeInput>
                                <input matStartDate placeholder="Start date" formControlName="startDate">
                                <input matEndDate placeholder="End date" formControlName="endDate">
                            </mat-date-range-input>

                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker (closed)="onDateChange($event)"> </mat-date-range-picker>
                        </mat-form-field>

                        <app-error-message [form]="rangePickerForm" controlName="endDate"></app-error-message>


                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="admin-dashboard-cards">
        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <div class="icon">
                <svg width="35" height="35" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_10611_12140)">
                        <path
                            d="M24.4311 4.97959C23.6918 4.21049 22.6674 3.80273 21.5934 3.80273H5.36924C4.29515 3.80273 3.27409 4.23701 2.50498 4.97959C1.7359 5.74538 1.32812 6.76974 1.32812 7.84385V18.6411C1.32812 19.1782 1.43753 19.702 1.63975 20.1893C1.83866 20.6766 2.13369 21.1242 2.50498 21.5087C3.27409 22.2745 4.29515 22.6855 5.36924 22.6855H16.077C16.0704 22.5629 16.0671 22.4369 16.0671 22.3143C16.0671 20.1495 16.9423 18.0312 18.4705 16.5062C19.9988 14.9779 22.1138 14.1027 24.2786 14.1027C24.7261 14.1027 25.1704 14.1392 25.6079 14.2155V7.84385C25.6079 6.76974 25.1737 5.74538 24.4311 4.97959ZM24.2786 13.2441H2.68401V9.19971H24.2786V13.2441Z"
                            fill="#0CA811" />
                        <path
                            d="M29.1538 17.4419C27.8642 16.1524 26.1105 15.4297 24.2839 15.4297C22.4573 15.4297 20.7036 16.1524 19.414 17.4419C18.1244 18.7348 17.3984 20.4885 17.3984 22.3152C17.3984 24.1385 18.1244 25.8955 19.414 27.185C20.7036 28.4746 22.4573 29.1973 24.2839 29.1973C26.1105 29.1973 27.8642 28.4746 29.1538 27.185C30.4434 25.8955 31.1694 24.1385 31.1694 22.3152C31.1694 20.4885 30.4434 18.7348 29.1538 17.4419ZM22.9512 26.406L18.9698 22.3549L19.9875 21.5361L22.2915 23.3428C23.2297 22.2223 25.3248 19.988 28.2123 18.221L28.451 18.7912C25.8055 21.2245 23.6308 24.649 22.9512 26.406Z"
                            fill="#0CA811" />
                    </g>
                    <defs>
                        <clipPath id="clip0_10611_12140">
                            <rect width="31.4062" height="31.4062" fill="white"
                                transform="translate(0.546875 0.796875)" />
                        </clipPath>
                    </defs>
                </svg>
            </div>

            <div class="content">

                <div class="top">
                    <span class="title">
                        Approved Transactions
                    </span>
                </div>

                @if(periodicCountByStatus){
                <div class="card-value">
                    <p class="count">({{periodicCountByStatus?.paid?.totalCount | number }})</p>
                    <p class="value approved">{{periodicCountByStatus?.paid?.totalAmount | nairaCurrency }}</p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }
            </div>
        </div>



        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <div class="icon" style="background-color: #FFF1B4;">
                <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M13.7361 11.7949C14.5363 11.7949 15.1849 12.4436 15.1849 13.2437V21.658C15.1849 23.5719 16.1244 25.2663 17.5674 26.3053C18.0107 26.6245 18.3277 27.112 18.3277 27.6583V28.1046C18.3277 30.2249 16.6088 31.9438 14.4885 31.9438H7.05019C4.92983 31.9438 3.21094 30.2249 3.21094 28.1046V15.6342C3.21094 13.5138 4.92983 11.7949 7.05019 11.7949H13.7361ZM10.7694 28.1833C10.5074 28.1833 10.2704 28.0763 10.0996 27.9037L7.41738 25.2214C7.04964 24.8536 7.04964 24.2574 7.41738 23.8896C7.78515 23.5219 8.38139 23.5219 8.74916 23.8896L9.82767 24.9681V16.4972C9.82767 15.9771 10.2493 15.5555 10.7694 15.5555C11.2894 15.5555 11.7111 15.9771 11.7111 16.4972V24.9682L12.7896 23.8896C13.1574 23.5219 13.7536 23.5219 14.1214 23.8896C14.4891 24.2574 14.4891 24.8536 14.1214 25.2214L11.4353 27.9075C11.4186 27.9242 11.4013 27.9402 11.3835 27.9555C11.2186 28.0975 11.004 28.1833 10.7694 28.1833Z"
                        fill="#BC9A03" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M20.9096 25.4966C18.7892 25.4966 17.0703 23.7777 17.0703 21.6573V9.18691C17.0703 7.06656 18.7892 5.34766 20.9096 5.34766H28.3454C30.4658 5.34766 32.1847 7.06656 32.1847 9.18691V21.6573C32.1847 23.7777 30.4658 25.4966 28.3454 25.4966H20.9096ZM24.6275 20.857C24.1074 20.857 23.6857 20.4354 23.6857 19.9153V13.2024L23.0468 13.8415C22.679 14.2092 22.0828 14.2092 21.715 13.8415C21.3472 13.4737 21.3472 12.8775 21.715 12.5097L23.9466 10.2781C24.1181 10.0987 24.3597 9.98693 24.6275 9.98693C24.894 9.98693 25.1346 10.0976 25.3059 10.2755L27.5401 12.5097C27.9078 12.8775 27.9078 13.4737 27.5401 13.8415C27.1723 14.2092 26.5761 14.2092 26.2083 13.8415L25.5692 13.2024V19.9153C25.5692 20.4354 25.1476 20.857 24.6275 20.857Z"
                        fill="#BC9A03" />
                </svg>

            </div>

            <div class="content">

                <div class="top">
                    <span class="title">
                        Initiated Transactions
                    </span>
                </div>

                @if(periodicCountByStatus){
                <div class="card-value">
                    <p class="count">({{periodicCountByStatus?.initialized?.totalCount | number }})</p>
                    <p class="value initiated">{{periodicCountByStatus?.initialized?.totalAmount | nairaCurrency }}</p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }
            </div>
        </div>


        <div class="admin-dashboard-card admin-dashboard-card-2"
            style="background-image: url('./assets/images/dashboard-card-white-with-curves.jpg')">

            <div class="icon" style="background-color: #FFD9DA;">
                <svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M4.67056 25.6123H18.5469C18.9771 25.6123 19.2999 25.2895 19.2999 24.8593C19.2999 24.429 18.9771 24.1063 18.5469 24.1063H4.67056C3.70244 24.1063 2.94946 23.3533 2.94946 22.3852V12.8116H28.8734V15.9311C28.8734 16.3614 29.1961 16.6841 29.6264 16.6841C30.0567 16.6841 30.3794 16.3614 30.3794 15.9311V8.07861C30.3794 6.35752 28.981 4.85156 27.1523 4.85156H4.56299C2.84189 4.85156 1.33594 6.24995 1.33594 8.07861V22.3852C1.44351 24.1063 2.94946 25.6123 4.67056 25.6123ZM2.94946 8.07861C2.94946 7.1105 3.70244 6.35752 4.67056 6.35752H27.2599C28.228 6.35752 28.981 7.1105 28.981 8.07861V9.69214H2.94946V8.07861Z"
                        fill="#CE2A2D" />
                    <path
                        d="M17.0357 15.8241C17.0357 15.5014 16.713 15.1787 16.3903 15.1787H7.24697C6.92427 15.1787 6.60156 15.5014 6.60156 15.8241C6.60156 16.1468 6.92427 16.4695 7.24697 16.4695H16.3903C16.713 16.4695 17.0357 16.1468 17.0357 15.8241Z"
                        fill="#CE2A2D" />
                    <path
                        d="M7.24697 20.127C6.92427 20.127 6.60156 20.4497 6.60156 20.7724C6.60156 21.0951 6.92427 21.4178 7.24697 21.4178H10.5816C10.9043 21.4178 11.227 21.0951 11.227 20.7724C11.227 20.4497 10.9043 20.127 10.5816 20.127H7.24697Z"
                        fill="#CE2A2D" />
                    <path
                        d="M26.6074 29.2704C29.7269 29.2704 32.3085 26.6888 32.3085 23.5693C32.3085 20.4498 29.7269 17.8682 26.6074 17.8682C23.4879 17.8682 20.9062 20.4498 20.9062 23.5693C20.9062 26.6888 23.4879 29.2704 26.6074 29.2704ZM23.9182 21.7406C23.703 21.5255 23.703 21.0952 23.9182 20.8801C24.1333 20.6649 24.5636 20.6649 24.7787 20.8801L26.6074 22.7087L28.436 20.8801C28.6512 20.6649 29.0814 20.6649 29.2966 20.8801C29.5117 21.0952 29.5117 21.5255 29.2966 21.7406L27.4679 23.5693L29.2966 25.3979C29.5117 25.6131 29.5117 26.0434 29.2966 26.2585C29.189 26.3661 28.9739 26.4736 28.8663 26.4736C28.7587 26.4736 28.5436 26.3661 28.436 26.2585L26.6074 24.4298L24.7787 26.2585C24.6711 26.3661 24.456 26.4736 24.3484 26.4736C24.2409 26.4736 24.0257 26.3661 23.9182 26.2585C23.703 26.0434 23.703 25.6131 23.9182 25.3979L25.7468 23.5693L23.9182 21.7406Z"
                        fill="#CE2A2D" />
                </svg>

            </div>

            <div class="content">

                <div class="top">
                    <span class="title">
                        Failed Transactions
                    </span>
                </div>


                @if(periodicCountByStatus){
                <div class="card-value">
                    <p class="count">({{periodicCountByStatus?.failed?.totalCount | number }})</p>
                    <p class="value failed">{{periodicCountByStatus?.failed?.totalAmount | nairaCurrency }}</p>
                </div>
                }
                @else {
                <span class="spinner-light"></span>
                }

            </div>
        </div>



    </div>


    <div class="row gx-2 gy-2">
        <div class="col-xl-6">
            <div class="chart-wrapper">
                <div class="graph">
                    <ngx-charts-line-chart [scheme]="lineChartColorScheme" [legend]="true" [xAxis]="showXAxis"
                        [yAxis]="showYAxis" [showXAxisLabel]="showXAxisLabel" [showYAxisLabel]="showYAxisLabel"
                        [legendTitle]="null"  [timeline]="" [results]="lineChartData"
                        [legendPosition]="legendPosition.Below">
                    </ngx-charts-line-chart>
                </div>

            </div>
        </div>
        <div class="col-xl-6">
                <div class="chart-wrapper">
                    <div class="graph">

                    <ngx-charts-bar-vertical-2d [scheme]="barChartColorScheme" [results]="barChartData"
                        [gradient]="gradient" [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend"
                        [legendPosition]="legendPosition.Below"  [legendTitle]="null" (select)="onSelect($event)">
                    </ngx-charts-bar-vertical-2d>
                </div>
            </div>

        </div>
        <div class="col-12">
            <div class="transaction-list">
                <h5 class="responsive-title d-xl-none mb-2" style="color: #2f2f2f;">TRANSACTIONS:</h5>

                <div class="panel-div">
                    <div class="table-wrapper border-radius-full">
                        <!-- <table class="role-table amc-table" appAutoDataLabel>
    
    
                                <thead class="amc-table-heading">
                                    <tr>
                                        <th>S/N</th>
                                        <th>Revenue Name</th>
                                        <th>Revenue Code</th>
                                        <th>Transaction Amount</th>
                                        <th>Transaction Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @if( isSearching){
                                    <tr class="border-0 tr-table-loader">
                                        <td [colSpan]="6" class="td-table-loader">
                                            <app-bounce-loader></app-bounce-loader>
                                        </td>
                                    </tr>
                                    } @else { @if(!searchedtransactionsNotFound){
                                    <tr *ngFor="let transaction of transactions; let i = index">
                                        <td>
                                            {{ i + (pageSize * (currentPage - 1)) + 1 }}
                                        </td>
                                        <td>
                                            {{ transaction?.revenueName }}
                                        </td>
                                        <td>
                                            {{ transaction?.revenueCode }}
                                        </td>
                                        <td>
                                            {{ transaction?.transactionAmount | nairaCurrency }}
                                        </td>
                                        <td>
                                            {{ transaction?.transactionCount }}
                                        </td>
                                    </tr>
                                    } @else{
                                    <tr class="tr-empty-placeholder">
                                        <td colspan="6" class="text-center">No results found</td>
                                    </tr>
                                    } }
                                </tbody>
                            </table> -->

                        <table class="role-table amc-table" appAutoDataLabel>
                            <thead class="amc-table-heading">
                                <tr>
                                    <th>S/N</th>
                                    <th>Payment Reference</th>
                                    <th>Transaction Amount</th>
                                    <th>Transaction Type</th>
                                    <th>Transaction Date</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let transaction of transactions; let i = index">
                                    <td>
                                        {{ i + (pageSize * (currentPage - 1)) + 1 }}
                                    </td>
                                    <td>
                                        {{ transaction?.paymentReference }}
                                    </td>
                                    <td>
                                        {{ transaction?.amount | nairaCurrency }}
                                    </td>
                                    <td>
                                        {{ transaction?.transactionType }}
                                    </td>
                                    <td>
                                        {{ transaction?.paymentDate | date }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                        @if(errorFetchingTransactionHistory) {
                        <p class="text-center text-danger p-3">Error Fetching Data</p>
                        }

                        @if(isSearching) {
                        <div class="p-4">
                            <app-bounce-loader></app-bounce-loader>
                        </div>
                        }

                        @if(searchedtransactionsNotFound) {
                        <p class="text-center text-danger p-3">No transactions within this period</p>
                        }
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mt-2 flex-wrap">
                    <div class="d-flex align-items-center me-4">
                        <div>Rows per page:</div>
                        <div class="mx-2">
                            <select class="form-control px-6 text-center" style="width: auto; min-width: 40px"
                                [(ngModel)]="selectedLimit" (change)="updateLimit()">
                                <option [value]="5">5</option>
                                <option [value]="10">10</option>
                                <option [value]="20">20</option>
                                <option [value]="30">30</option>
                                <option [value]="40">40</option>
                                <option [value]="50">50</option>
                            </select>
                        </div>
                    </div>

                    <div class="pagination-container">
                        <ngb-pagination *ngIf="!isSearching && count > 0" [(page)]="currentPage"
                            (pageChange)="onPageChange($event)" [maxSize]="5" [pageSize]="pageSize"
                            [collectionSize]="count" [boundaryLinks]="true" [directionLinks]="true" [rotate]="true"
                            class="pagination justify-content-center my-3">
                        </ngb-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>










</div>

<!-- <app-bounce-loader></app-bounce-loader> -->